//Connect to Navbar to dynamicly link and create multiple navbar items
//This is an array of item
export const MenuItems = [
    {
        title : "Home",
        url : "/",
        cName : "nav-links",
        icon : "fa-solid fa-house-user"
    },
    {
        title : "Service",
        url : "/service",
        cName : "nav-links",
        icon : "fa-solid fa-briefcase"
    },
    {
        title : "Gallery",
        url : "/gallery",
        cName : "nav-links",
        icon : "fa-solid fa-image"
    },
    {
        title : "Contact",
        url : "/contact",
        cName : "nav-links",
        icon : "fa-solid fa-address-book"
    },
    {
        title : "Hiring",
        url : "/jobs",
        cName : "nav-links",
        icon : "fa-solid fa-users"
    },    
    {
        title : "Book Now",
        url : "https://cal.com/b-chau-kbji58",
        cName : "nav-links-mobile",
        external: true
    },
    
    
];